import dayjs from 'dayjs'

export function formatTime(date) {
	return format(date, 'YYYY-MM-DD HH:mm:ss')
}

export function formatMonth(date) {
	return format(date, 'YYYY-MM')
}

export function formatDate(date) {
	return format(date, 'YYYY-MM-DD')
}

export function formatMinute(date) {
	return format(date, 'YYYY-MM-DD HH:mm')
}

export function formatDatetime(date) {
	return format(date, 'YYYY-MM-DD HH:mm:ss')
}

export function format(date, formatStr) {
	if (!date) {
		return ''
	}
	return dayjs(date).format(formatStr)
}

export function num99(num, max = 99) {
	function fn(val) {
		if (!val) {
			return 0
		}
		return val > max ? `${max}+` : val
	}
	if (Array.isArray(num)) {
		return num.map(item => {
			return fn(item)
		})
	}
	return fn(num)
}
